const user = {
  state: {
    token: localStorage.getItem('token') || '',
    userinfo: "",
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, info) => {
      state.userinfo = info
    },
  },
  actions: {
    SetToken({ commit }, token) {
      commit('SET_TOKEN', token)
      localStorage.setItem('token', token)
    },
    // 获取用户信息
    SetUserInfo({ commit }, info) {
      commit('SET_USERINFO', info)
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        localStorage.setItem('token', '');
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js